/* @flow */
import { GLYPHS } from 'constants/MediumConstants';
import Glyph from 'components/Glyph';
import Heading from 'components/Heading';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import PropTypes from 'prop-types';
import * as React from 'react';
import Subscriber from 'entities/Subscriber';
import Text from 'components/Text';
import cx from 'classnames';

import './styles/RelationshipViewMediums.scss';

class RelationshipViewNotes extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    subscriber: PropTypes.instanceOf(Subscriber).isRequired,
  };

  render() {
    const { subscriber } = this.props;

    const enabledDevices = subscriber.getDevices().filter(device => device.isEnabled());

    let mediums;
    if (enabledDevices.length > 0) {
      mediums = enabledDevices.map(device => {
        const medium = device.getMedium();
        const verified = device.isVerified();

        return (
          <div
            key={device.cid}
            className={cx('RelationshipViewMediums-list-item', {
              'RelationshipViewMediums-list-item--disabled': !verified,
            })}>
            <Glyph className="RelationshipViewMediums-list-item-glyph" name={GLYPHS[medium]} />
            {device.getFriendlyName()}
          </div>
        );
      });
    } else {
      mediums = (
        <Text color="thunder">
          Oops, messages may not be received. This person doesn’t have any notifications enabled.{' '}
          <Link href={LinkConstants.NO_DEVICES} target="_blank">
            View FAQ.
          </Link>
        </Text>
      );
    }
    return (
      <div className="RelationshipViewMediums">
        <Heading level="3" levelStyle="5">
          Notifications
        </Heading>
        <div className="RelationshipViewMediums-list">{mediums}</div>
      </div>
    );
  }
}
export default RelationshipViewNotes;
